import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SkeletonBody from '@afosto/components-react/SkeletonBody';
import { routing as routingApi } from '@afosto/wms/api/Routing';
import { array as arrayFormatter } from '@afosto/app-components-react/DataGrid/formatters';

const RoutesFormatter = ({ routeIds }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [routes, setRoutes] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchRoutes = async ids => {
      setIsLoading(true);

      try {
        const promises = ids.map(id => routingApi.viewRoute(id));
        const responses = await Promise.allSettled(promises).then(result =>
          result.filter(promise => promise.status === 'fulfilled'),
        );
        const formattedRoutes = responses.reduce(
          (acc, response) => [...acc, response.value.data],
          [],
        );

        if (isMounted) {
          setRoutes(formattedRoutes);
        }
      } catch (err) {
        if (isMounted) {
          setRoutes(null);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    if (routeIds.length > 0) {
      fetchRoutes(routeIds);
    }

    return () => {
      isMounted = false;
    };
  }, [routeIds]);

  if (isLoading) {
    return <SkeletonBody lines={1} />;
  }

  if (!routes?.length) {
    return '-';
  }

  return arrayFormatter(routes.map(route => route.name));
};

RoutesFormatter.propTypes = {
  routeId: PropTypes.string,
};

RoutesFormatter.defaultProps = {
  routeId: undefined,
};

export default RoutesFormatter;
